import { render, staticRenderFns } from "./orderDetailShow.vue?vue&type=template&id=5e45f736&scoped=true"
import script from "./orderDetailShow.vue?vue&type=script&lang=js"
export * from "./orderDetailShow.vue?vue&type=script&lang=js"
import style0 from "./orderDetailShow.vue?vue&type=style&index=0&id=5e45f736&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45f736",
  null
  
)

export default component.exports